import React, { useMemo } from 'react';

import styles from './styles.module.less';
import { STATUS_MAPPING } from '../../config/statusMapping';

const DecisionStatus = ({ status }) => {
  const { text, icon: Icon } = useMemo(() => STATUS_MAPPING[status], [status]);

  return (
    <div className={styles.wrapper}>
      <Icon size={40} />

      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default DecisionStatus;
